import ConsumerListing from "./consumerListing.container";

export default ConsumerListing;
